import { useHistory, useParams } from 'react-router-dom'
import useEntity from '../../hooks/useEntity'
import Loading from '../../components/Loading'
import * as React from 'react'
import LegalPersonForm, { LegalPersonMutationDto } from '../../components/Form/Party/LegalPersonForm'
import useAxios from '../../hooks/useAxios'
import { getPartyOverviewUrl } from './AddNaturalPerson'
import { sortTiers } from '../../components/Form/Tier/TierList'
import useUsers from '../../hooks/useUsers'
import useAttributes, { AttributeContextType, AttributeViewType, EntityAttributeType } from '../../hooks/useAttributes'

export default function EditLegalPerson() {
    const axios = useAxios()
    const history = useHistory()
    const { fileId, id } = useParams<{ fileId?: string; id?: string }>()
    const users = useUsers()

    const attributes = useAttributes(AttributeViewType.Input, [AttributeContextType.LegalPerson], undefined, EntityAttributeType.Party)

    const [entity] = useEntity<LegalPersonMutationDto>(
        id => ({ url: `/party/${id}` }),
        id,
        response => ({
            ...response.data,
            tiers: sortTiers(users, response.data.tiers),
        }),
    )

    if (!entity.loaded) {
        return <Loading />
    }

    return (
        <LegalPersonForm
            formikProps={{
                initialValues: {
                    addressCountry: 'NL',
                    poBoxAddressCountry: 'NL',
                    ...entity.data,
                },
            }}
            onSubmit={(party: LegalPersonMutationDto) => axios.put<string>(`/party/legal/${id}`, party)}
            goBack={() => history.replace(getPartyOverviewUrl(fileId))}
            attributes={attributes}
        />
    )
}
